export default __webpack_public_path__ + "9b7cb4f15eb1bc5b01146714a5f64db7.png";